import { render, staticRenderFns } from "./timestatistical.vue?vue&type=template&id=3543a984&scoped=true"
import script from "./timestatistical.vue?vue&type=script&lang=ts"
export * from "./timestatistical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543a984",
  null
  
)

export default component.exports